/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import MapboxMap from '../../../components/stateful/Map';
import styles from './styles.scss';
import { MarkerFragment } from '../../../components/stateful/Map/FacilityPopupContent';

const propTypes = {
  facility: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.shape({
      latitude: PropTypes.number,
      longitude: PropTypes.number,
    }).isRequired,
  }),
  zoom: PropTypes.number,
  center: PropTypes.shape({
    lat: PropTypes.string,
    lng: PropTypes.string,
  }),
  options: PropTypes.shape({
    zoom: PropTypes.number,
    center: PropTypes.shape({
      lat: PropTypes.string,
      lng: PropTypes.string,
    }),
  }),
  mapProps: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  isEditable: PropTypes.bool,
};

const defaultProps = {
  facility: undefined,
  zoom: undefined,
  center: undefined,
  options: undefined,
  mapProps: undefined,
  isEditable: undefined,
};

export const defaultMapOptions = {
  zoom: 13,
};

export const Map = ({
  zoom = defaultMapOptions.zoom,
  center,
  facility,
  mapProps = {},
  colors,
  mapStyle,
  isEditable,
}) => {
  const renderBroken = () => (isEditable ? (
      <h1>Facility not found. This map will be empty on the live site.</h1>
  ) : (
      <div />
  ));

  if (!facility?.address) {
    return renderBroken();
  }

  const { latitude, longitude } = facility.address;

  const facilityWithMinPrice = {
    ...facility,
    minimumUnitPrice: Math.min(
      ...facility.unitSummary.map(({ minPrice }) => minPrice),
    ),
  };

  return (
    <div className={styles.smallMap}>
      <MapboxMap
        className={styles.mapContainer}
        center={center || { latitude, longitude }}
        zoom={zoom}
        {...mapProps}
        facilities={[{ ...facilityWithMinPrice, latitude, longitude }]}
        enableClustering={false} // We always want to show normal pin for 1 facility
        colors={colors}
        mapStyle={mapStyle}
      />
    </div>
  );
};

Map.propTypes = propTypes;
Map.defaultProps = defaultProps;

Map.fragments = {
  facility: gql`
    fragment MapFacility on Facility {
      address {
        latitude
        longitude
      }
      unitSummary {
        minPrice
      }
      ...FacilitiesMapMarkerFacility
    }

    ${MarkerFragment}
  `,
};

export default Map;
